import { useMemo } from 'react'
import { useFetchAssignmentsQuery } from '../store/apis/assignment.api'
import { CS_LANGUAGES } from '../constants/languages'
import { ASSIGNMENT_TYPES } from '../constants/assignment-types'

/**
 * Custom hook to check if there are any CS assignments in the account
 * CS assignments are defined as assignments in any language except NEW_TEXT and EXCEL
 *
 * @returns {boolean} true if there are CS assignments, false otherwise
 */
const useHasCSMbas = () => {
    // Fetch assignments with CS languages filter
    const { data: assignmentsData, isLoading } = useFetchAssignmentsQuery({
        language: CS_LANGUAGES,
        type: ASSIGNMENT_TYPES.MODEL_BOUND_ASSIGNMENT.value,
        pageSize: 1,
    })

    // Check if any CS assignments exist
    const hasCSAssignments = useMemo(() => {
        if (isLoading || !assignmentsData) {
            return false
        }

        // If we have any assignments returned, there are CS assignments
        return assignmentsData.assignments && assignmentsData.assignments.length > 0
    }, [assignmentsData, isLoading])

    return hasCSAssignments
}

export default useHasCSMbas
